import { DEXIE_IS_LOADING } from './db';
import { getMetaContent } from './meta';

/**
 * Build the base path for a workspace
 * @param {Object} workspace - Workspace object with id property
 * @returns {string} The workspace path
 */
export const buildWorkspaceUrl = (workspace) => {
  return `/spaces/${workspace.id}`;
};

/**
 * Build the invite URL for a workspace
 * @deprecated Invite links are legacy join URLs. New sharing UI should use
 * buildChannelShareUrl with the workspace main channel Share Link instead.
 * @param {Object} workspace - Workspace object with slug and invite_key properties
 * @returns {string} The workspace invite URL
 */
export const buildWorkspaceInviteUrl = (workspace) => {
  return `https://${workspace.slug}.${getMetaContent('env:default_host')}/join/${workspace.invite_key}`;
};

/**
 * Check if workspace has a paid subscription tier (custom or paid_1).
 * Mirrors Workspace.scope :paid in Ruby.
 * @param {Object|string} workspaceOrTier - Workspace object with subscription_tier or tier string
 * @returns {boolean}
 */
export const isPaidWorkspace = (workspaceOrTier) => {
  if (workspaceOrTier === DEXIE_IS_LOADING) return false;
  const tier = typeof workspaceOrTier === 'string' ? workspaceOrTier : workspaceOrTier?.subscription_tier;
  return tier ? ['custom', 'paid_1'].includes(tier) : false;
};

/**
 * Check if workspace has a free subscription tier.
 * @param {Object|string} workspaceOrTier - Workspace object with subscription_tier or tier string
 * @returns {boolean}
 */
export const isFreeWorkspace = (workspaceOrTier) => {
  if (workspaceOrTier === DEXIE_IS_LOADING) return false;
  const tier = typeof workspaceOrTier === 'string' ? workspaceOrTier : workspaceOrTier?.subscription_tier;
  return (tier || 'free') === 'free';
};

/**
 * Whether audio/video calling should be offered in this workspace. Every workspace
 * gets AV; its admins switch it off in workspace settings. Column defaults to true,
 * so a workspace row cached before the field existed reads as on rather than
 * silently killing calls until the next sync. The v1 livekit endpoint enforces the
 * same flag, so this only governs whether the UI is offered.
 * @param {Object} workspace - Serialized workspace
 * @returns {boolean}
 */
export const isAvCallingEnabled = (workspace) => {
  if (workspace === DEXIE_IS_LOADING) return false;
  return workspace?.av_calling_enabled !== false;
};
